import React from "react";
import { TRIGGERS } from "../../../constants/sequence";
import TriggerListCard from "./TriggerListCard";
import { useSelector } from "react-redux";
import { useFunction } from "../../../../../hooks/useFeatureGating";
import { FUNCTIONS } from "../../../../../constant/featureSlugs";
import { Tooltip } from "antd";
import { cn } from "../../../../../helper/cn";

export default function TriggerList({ onSelectTrigger }) {
  const featureFlags = useSelector((state) => state.app.featureFlags);
  const isApiTriggerEnabled = featureFlags?.api_trigger_feature;
  const isKeywordTriggerEnabled = featureFlags?.keyword_trigger_feature;

  // CMS Feature Gating
  const { isEnabled: canUseBroadcastTrigger } = useFunction(FUNCTIONS.SEQUENCE_BROADCAST_TRIGGER);
  const { isEnabled: canUseQrTrigger } = useFunction(FUNCTIONS.SEQUENCE_QR_TRIGGER);
  const { isEnabled: canUseKeywordTrigger } = useFunction(FUNCTIONS.SEQUENCE_KEYWORD_TRIGGER);
  const { isEnabled: canUseApiTrigger } = useFunction(FUNCTIONS.SEQUENCE_API_TRIGGER);

  const getTriggerPermission = (key) => {
    switch (key) {
      case "CAMP_WAPP_BCAST":
        return canUseBroadcastTrigger;
      case "CAMP_QR_URL":
        return canUseQrTrigger;
      case "KEYWORD_TRIGGER":
        return canUseKeywordTrigger && isKeywordTriggerEnabled;
      case "API_TRIGGER":
        return canUseApiTrigger && isApiTriggerEnabled;
      default:
        return true;
    }
  };

  return (
    <div className="w-full h-full rounded-3xl">
      <div className="w-full px-5 py-2.5 rounded-t-xl bg-gradient-to-r from-[#9879FF] to-[#FFAC97]">
        <div></div>
        <div className="text-white">Triggers</div>
      </div>
      <div className="w-full h-full px-5 pb-4 rounded-b-3xl bg-white">
        {TRIGGERS?.map((t) => {
          const show = t?.list?.filter((l) => {
            if (l?.disabled) return false;
            if (l?.key === "API_TRIGGER" && !isApiTriggerEnabled) return false;
            if (l?.key === "KEYWORD_TRIGGER" && !isKeywordTriggerEnabled) return false;
            return true;
          });

          if (show?.length === 0) return null;

          return (
            <div key={t?.id} className="">
              <div className="text-xs weight-semibold py-3.5 text-[var(--font-600)]">
                {t?.title}
              </div>
              <div className="grid grid-cols-1 gap-3">
                {t?.list?.map((l) => {
                  if (l?.disabled) return null;
                  
                  const isAllowed = getTriggerPermission(l?.key);

                  return (
                    <Tooltip 
                      key={l?.id} 
                      title={!isAllowed ? "This trigger is not available in your plan. Upgrade to access." : ""}
                    >
                      <div
                        className={cn(
                          "transition-all duration-200 rounded-lg overflow-hidden",
                          isAllowed ? "hover:shadow-md cursor-pointer" : "cursor-not-allowed"
                        )}
                        onClick={(event) => {
                          event.stopPropagation();
                          if (isAllowed && !l?.disabled) onSelectTrigger(l);
                        }}
                      >
                        <TriggerListCard data={{ ...l, disabled: !isAllowed }} />
                      </div>
                    </Tooltip>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
